<template>
  <div class="new">
    <div class="news_wrap">
      <h2>右边栏新闻设置</h2>
      <div class="list-news">
        <div class="list-news-item" v-for="(item, index) in list" :key="index">
          <div class="title">
            <h2><span v-if="item.seq != null">热文</span> {{ item.title }}</h2>
            <li>
              <p>
                {{ filterContent(item.content) }}
              </p>
            </li>
          </div>
          <div class="but-list">
            <el-button type="primary" size="mini" @click="edit(item, index + 1)"
              >更改</el-button
            >
            <el-button
              type="warning"
              size="mini"
              v-if="item.seq != null"
              @click="revokeNews(item)"
              >撤销</el-button
            >
            <el-button type="danger" size="mini" @click="delNew(item)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
      <h2>下方新闻设置</h2>
      <div class="img-list">
        <div
          class="img-list-item"
          v-for="(item, index) in imgList"
          :key="index"
        >
          <div
            class="news-img"
            :style="`background-image:url(${$utils.fileUrl(item.cover)})`"
          ></div>
          <div class="title">
            <li>
              <h2>
                {{ item.title }}
              </h2>
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="edit(item, index + 3)"
                  >更改</el-button
                >
                <el-button
                  type="warning"
                  size="mini"
                  v-if="item.seq != null"
                  @click="revokeNews(item)"
                  >撤销</el-button
                >
                <el-button type="danger" size="mini" @click="delNew(item)"
                  >删除</el-button
                >
              </div>
            </li>
            <li class="news-content">
              <p>
                {{ filterContent(item.content) }}
              </p>
            </li>
            <li class="date">
              日期：{{ $utils.formatDate(item.publishTime, "yyyy-MM-dd") }}
            </li>
          </div>
        </div>
      </div>
      <h2>轮播图新闻设置</h2>
      <ul class="banner">
        <li v-for="(item, index) in banner" :key="index">
          <div
            class="cover"
            :style="`background-image: url(${$utils.fileUrl(item.cover)})`"
          ></div>
          <div class="title">
            <span v-if="item.seq != null">热文</span>
            {{ item.title }}
          </div>
          <div>
            <el-button type="primary" size="mini" @click="edit(item, index + 5)"
              >更改</el-button
            >
            <el-button
              type="warning"
              size="mini"
              v-if="item.seq != null"
              @click="revokeNews(item)"
              >撤销</el-button
            >
            <el-button type="danger" size="mini" @click="delNew(item)"
              >删除</el-button
            >
          </div>
        </li>
      </ul>
    </div>

    <!-- 广告 -->
    <el-dialog
      v-model="dialog"
      title="更改"
      width="500px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="close"
    >
      <div>
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          size="small"
          label-width="100px"
          label-position="right"
        >
          <el-form-item label="选择资讯：" prop="id">
            <el-select
              v-model="form.id"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialog = false" size="mini">取消</el-button>
          <el-button @click="setData" type="primary" size="mini"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banner: [],
      list: [],
      imgList: [],
      dialog: false,
      form: {
        title: "",
        id: "",
      },

      rules: {
        id: [{ required: true, message: "请选择新闻", trigger: "change" }],
      },
      options: [],
      loading: false,
      itemData: {},
    };
  },
  methods: {
    filterContent(val) {
      let str = val.replace(/<\/?[^>]*>/g, "").replace(/&nbsp;/gi, "");
      return str;
    },
    async getData() {
      try {
        const res = await this.$api.pageManage.home.getNewsInfo();
        if (res.code === 10200) {
          this.banner = [];
          this.list = [];
          this.imgList = [];
          res.data.forEach((item, index) => {
            if (index <= 1) {
              this.list.push({ ...item });
            } else if (index < 4) {
              this.imgList.push({ ...item });
            } else {
              this.banner.push({ ...item });
            }
          });
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {}
    },
    async remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        const res = await this.$api.pageManage.home.getNewsList({
          title: query,
        });
        this.loading = false;
        if (res.code === 10200) {
          this.options = res.data;
        }
      } else {
        this.options = [];
      }
    },
    delNew(data) {
      if (!this.loading) {
        this.$confirm("是否确认删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const res = await this.$api.pageManage.home.delNews({
                id: data.id,
                type: 1,
              });
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData();
                this.$message.success("删除成功");
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
    revokeNews(data) {
      if (!this.loading) {
        this.$confirm("是否确认撤销?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            try {
              this.loading = true;
              this.$loading.start();
              const res = await this.$api.pageManage.home.revokeNews({
                id: data.id,
                type: 1,
              });
              this.loading = false;
              this.$loading.done();
              if (res.code === 10200) {
                this.getData();
                this.$message.success("撤销成功");
              } else {
                this.$message.error(res.msg);
              }
            } catch (error) {
              this.loading = false;
              this.$loading.done();
            }
          })
          .catch(() => {});
      }
    },
    edit(data, index) {
      this.itemData = { ...data };
      this.itemData.seq = index;
      this.dialog = true;
    },
    setData() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    close() {
      this.form.id = "";
    },
    async submit() {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            olderId: this.itemData.id,
            newsId: this.form.id,
            type: 1,
            seq: this.itemData.seq,
          };
          const res = await this.$api.pageManage.home.setNews(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.dialog = false;
            this.getData();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.new {
  & > .title {
    padding: 24px;
    font-size: 0.875rem;
    margin-bottom: 24px;
    background-color: #ffffff;

    .el-button {
      margin-left: 40px;
    }
  }

  .news_wrap {
    padding: 20px;
    background-color: #ffffff;

    h2 {
      font-size: 1.125rem;
    }

    .banner {
      max-width: 1000px;
      margin-bottom: 20px;
      li {
        display: flex;
        margin-top: 15px;
        align-items: flex-start;

        div {
          line-height: 40px;

          &:last-child {
            margin-left: auto;
          }
        }

        .cover {
          width: 100px;
          height: 60px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
        }

        .title {
          flex: 1;
          padding: 0 20px;
          font-size: 0.75rem;

          span {
            width: 60px;
            height: 20px;
            line-height: 20px;
            text-align: center;
            display: inline-block;
            color: $--color-danger;
            border: 1px solid $--color-danger;
            border-radius: $--border-radius-base;
          }
        }
      }
    }

    .list-news {
      max-width: 1000px;

      .list-news-item {
        height: 87px;
        display: flex;
        align-items: center;

        .title {
          flex: 1;
          padding-right: 20px;

          h2 {
            font-size: 1rem;
            cursor: pointer;
            font-weight: 500;
            line-height: 30px;
            transition: $--all-transition;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            &:hover {
              color: $--color-primary;
            }

            span {
              width: 60px;
              height: 20px;
              font-size: 0.875rem;
              line-height: 20px;
              text-align: center;
              display: inline-block;
              color: $--color-danger;
              border: 1px solid $--color-danger;
              border-radius: $--border-radius-base;
            }
          }

          li {
            padding-bottom: 15px;
            border-bottom: 1px dashed #979797;
            p {
              line-height: 26px;
              font-size: 0.875rem;
              color: $--color-text-regular;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              word-break: break-word;
              word-wrap: break-word;
              white-space: pre-wrap;
            }
          }

          // div {
          //   border-bottom: 1px dashed #979797;
          // }
        }
        .but-list {
          white-space: normal;
        }
      }
    }

    .img-list {
      max-width: 1000px;
      padding: 20px 0;
      .img-list-item {
        display: flex;
        &:first-child {
          margin-bottom: 24px;
        }

        .news-img {
          width: 250px;
          height: 150px;
          overflow: hidden;
          margin-right: 24px;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: $--border-radius-base;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .title {
          flex: 1;
          height: 150px;
          padding: 10px 0;
          box-sizing: border-box;

          li {
            &:first-child {
              display: flex;
              margin-bottom: 11px;
              align-items: center;

              h2 {
                flex: 1;
                padding-right: 20px;
                cursor: pointer;
                font-size: 1rem;
                font-weight: 400;
                line-height: 22px;
                transition: $--all-transition;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
                &:hover {
                  color: $--color-primary;
                }
              }
            }
          }

          .news-content {
            padding-bottom: 22px;
            height: 52px;
            p {
              line-height: 26px;
              font-size: 0.875rem;
              color: $--color-text-regular;
              text-overflow: -o-ellipsis-lastline;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              line-clamp: 2;
              -webkit-box-orient: vertical;
              word-break: break-word;
              word-wrap: break-word;
              white-space: pre-wrap;
            }
          }
          .date {
            line-height: 26px;
            font-size: 0.875rem;
            color: $--color-text-regular;
          }
        }
      }
    }
  }
}
</style>